import type { OrganizationsStatus } from '../types/auth';

/**
 * Rozstrzygnięcie dostępu do trasy chronionej.
 *
 * `'pending'` i `'unknown'` to NIE są odmiany „deny". Oba znaczą „nie wiemy",
 * różnią się tylko tym, czy odpowiedź jeszcze nadejdzie sama.
 */
export type AccessDecision = 'allow' | 'deny' | 'pending' | 'unknown';

/**
 * Zamienia „sprawdzenia odpowiedziały nie" na rozstrzygnięcie, które wolno
 * pokazać użytkownikowi.
 *
 * DLACZEGO TO JEST OSOBNA FUNKCJA. To jest cała własność, o którą tu chodzi:
 * odmowa dostępu wolno wypisać WYŁĄCZNIE wtedy, gdy znamy przynależność
 * użytkownika do organizacji. `canAccessPanel('admin')` to
 * `is_super_admin || organizations.length > 0`, a `hasRole` zwraca false bez
 * `currentOrganization` — obie funkcje mówią więc „nie" także wtedy, gdy dane
 * po prostu jeszcze nie dojechały. Wydzielenie tej decyzji z JSX pozwala ją
 * sprawdzić testem bez renderowania czegokolwiek.
 *
 * @param checksSaidNo wynik `!canAccessPanel(...) || !hasRole(...)`
 * @param status czy znamy już listę organizacji użytkownika
 */
export function resolveAccess(checksSaidNo: boolean, status: OrganizationsStatus): AccessDecision {
  // Zgoda nie zależy od organizacji: super-admin przechodzi przez
  // `canAccessPanel` bez nich, a użytkownik z wczytaną organizacją tym bardziej.
  // Dlatego „tak" jest odpowiedzią pewną niezależnie od statusu.
  if (!checksSaidNo) return 'allow';

  switch (status) {
    case 'loaded':
      // Znamy organizacje i sprawdzenia dalej mówią „nie" — to prawdziwa odmowa.
      return 'deny';
    case 'error':
      // Zapytanie padło. Odpowiedź NIE nadejdzie sama, więc spinner byłby
      // obietnicą bez pokrycia; konsument musi pokazać powód i ponowienie.
      return 'unknown';
    case 'loading':
      return 'pending';
  }
}
